import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import HandleContestDetails from './hooks/HandleContestDetails'
import Loader from '../../components/Loader'
import {
  BannerButtonContainer,
  CardAuthorName,
  CardBookCover,
  CardBookTitle,
  CardLeft,
  CardPositionImage,
  CardReadNow,
  CardReward,
  CardRight,
  ConfettiImg,
  Container,
  ExtraPadding,
  WinnerRewardNote,
  RewardNoteText,
  RowCard,
  SectionsContainer,
  WinnerUpperDiv,
  WinnerH2,
  WinnerStage1,
  WinnerTopImg,
  BannerButton,
  BannerContent,
  BannerHeading,
  BannerHeadingContainer,
  BannerHeadingLogo,
  BannerSubHeading,
  Accordion,
  AccordionBtn,
  AccordionText,
  BulbLogoContainer,
  Button,
  EarnBannerSection,
  EarnBtnContainer,
  EarnHeading,
  EarnSectionButton,
  EarnSubHeading,
  EarnWriterMessage,
  ExampleNovelImg,
  FaqSection,
  FlexContianerForStoryPoints,
  NoteChangeButton,
  NotesButtonForMobile,
  NotesFlexItem,
  NovelContent,
  SectionsCommonHeading,
  StoryWritingPoints,
  SuspenseNovelsContainer,
  TipsHeading,
  VerticalLeftItems,
  BannerMobileImg,
  BannerDesktopImg,
  BadgeDiv
} from './style'
import BlackLogo from './images/Blacklogo'
import ImportantNoteIcon from '../../components/Images/ImportantNoteIcon'
import ChevronRight from '../../components/Images/ChevronRight'
import StageContainer from './container/StageContainer'
import { chooseContestObject } from './contestData'
import Template1 from './template1'
import Template2 from './template2'
import { handleEventLog, handlePageLoadEventLog } from '../../lib/utils'
import HeadingImg from './images/web-bg.svg'
import HeadingImgUS from './images/contest-winner-bg.svg'
import LeaderBoard from './container/LeaderBoard'
import ThemesIdeasSection from './container/ThemesIdeasSection'
import ThemesIdeasPage from './container/ThemesIdeasPage'
import { Popup } from '../../components/Popup'
import { get } from '../../lib/api'
import PublicPageBackButtonNavbar from '../../components/PublicPage'
import badge from './images/winners_badge.svg'

const WinnerDiv = ({ winner, handleBookClick }) => (
  <WinnerUpperDiv>
    <RowCard key={winner?.book_id}>
      <CardLeft>
        <BadgeDiv>
          <CardPositionImage src={badge} alt="badge" />
          <p>{winner?.rank}</p>
        </BadgeDiv>
        <CardAuthorName>{winner.author_name}</CardAuthorName>
        <CardBookTitle>{winner.book_name}</CardBookTitle>
        <CardReward>Reward : {winner?.show_id ? '$'  : '₹'}{winner.amount}</CardReward>
      </CardLeft>
      <CardRight>
        <CardBookCover src={winner.book_image_url} alt="1" />
        <CardReadNow onClick={handleBookClick}>{ winner?.show_id ? 'LISTEN' : 'READ'}</CardReadNow>
      </CardRight>
    </RowCard>
    {winner?.reward_note && (
      <WinnerRewardNote>
        <ConfettiImg src="/images/celebration_confetti.png" />
        <RewardNoteText>{winner?.reward_note}</RewardNoteText>
      </WinnerRewardNote>
    )}
  </WinnerUpperDiv>
)

export default function Contest(props) {
  const { titleId } = useParams()
  const [contestType, setContestType] = useState('checking')
  const [activeTab, setActiveTab] = useState('winner')
  const [themeDetailsOpen, setThemeDetailsOpen] = useState({})
  const [leaderboardOpen, setLeaderboardOpen] = useState(false)
  const [leaderboardData, setLeaderBoardData] = useState({})
  const [defaultLeaderboardTab,setDefaultLeaderboardTab] = useState(null)
  const isMobile = window.screen.width < 600
  const [
    contestData,
    isLoading,
    handleJoinContestBtn,
    showNovelHandler,
    handleEarnButtonClick,
    toggleAccordionTextHandler,
    toggleExtraInfoHandler,
    checkContestStatus,
  ] = HandleContestDetails(titleId, contestType)
  const isUSContest = contestData?.locale === 'US'
  const [currentNotePoint, updateNotePoint] = useState(1)

  const isWinnersPageLive = contestData?.extra_info?.stage2
    ? contestData?.extra_info?.stage2?.winners ||
      contestData?.extra_info?.winners
    : contestData?.extra_info?.winners

  useEffect(() => {
    if (!titleId) {
      props.history.push('/404')
    }
    const params = new URLSearchParams( window.location.search);
   const leaderboardTabParams = params.get('defaultLeaderboardTab')
    if(leaderboardTabParams){
      setLeaderboardOpen(true)
      setDefaultLeaderboardTab(leaderboardTabParams)
      window.history.replaceState({}, document.title, window.location.href.split('?')[0]);
    }
    if (chooseContestObject[titleId]) {
      setContestType('static')
    } else {
      setContestType('dynamic')
    }
  }, [])

  useEffect(() => {
    if (contestData) {
      if (isWinnersPageLive && activeTab === 'winner') {
        handlePageLoadEventLog('contest_winner', {
          entity_id: contestData?.contest_id,
          entity_type: 'contest',
        })
      } else {
        handlePageLoadEventLog('contest_details', {
          entity_id: contestData?.contest_id,
          entity_type: 'contest',
        })
      }

      get('/content_api/contest.contest_leaderboard', {
        params: {
          contest_id: contestData.contest_id,
          is_novel: 1,
        },
      })
        .then((res) => {
          if (res.result) setLeaderBoardData(res.result)
          handleEventLog('popular_leaderboard_module', 'page_load', {
            entity_id: contestData.contest_id,
            entity_type: 'contest',
          })
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [contestData])

  const handleChangeToWinnersTab = () => {
    setActiveTab('winner')
    handlePageLoadEventLog('contest_winner', {
      entity_id: contestData?.contest_id,
      entity_type: 'contest',
    })
  }

  const handleClosePopup = () => {
    setThemeDetailsOpen({})
    window.location.hash = ''
  }

  const TopBannerSectionMobile = () => (
      <BannerContent>
        <BannerMobileImg
          src={contestData.extra_info.contest_intro.mobile_theme_image || contestData.extra_info.contest_intro.thumbnail_image}
          alt=""
        />
        <BannerDesktopImg
            src={contestData.extra_info.contest_intro.theme_image} 
            alt="" 
        />
        <BannerHeadingLogo>
          {!isUSContest &&<BlackLogo />}
        </BannerHeadingLogo>
        <BannerHeadingContainer>
          <BannerHeading>
            {contestData.extra_info.contest_intro.heading}
            <br />
          </BannerHeading>
          <BannerSubHeading>
            {contestData.extra_info.contest_intro.tagline}
          </BannerSubHeading>
          <BannerButtonContainer>
            {!isWinnersPageLive && (
              <BannerButton onClick={handleJoinContestBtn} activeTabColor>
                {!isUSContest ? 'JOIN THE CONTEST & WRITE' : 'Start your Audio Series'}
              </BannerButton>
            )}
            {contestData?.locale !== 'US' && !isWinnersPageLive && leaderboardData.popular && (
              <BannerButton
                onClick={() => setLeaderboardOpen(true)}
                activeTabColor={leaderboardOpen}
              >
                Leaderboard
              </BannerButton>
            )}
            {isWinnersPageLive && (
              <BannerButton
                onClick={() => setActiveTab('detail')}
                activeTabColor={activeTab === 'detail'}
              >
                CONTEST DETAILS
              </BannerButton>
            )}
            {isWinnersPageLive && (
              <BannerButton
                onClick={handleChangeToWinnersTab}
                activeTabColor={activeTab === 'winner'}
              >
                WINNERS
              </BannerButton>
            )}
          </BannerButtonContainer>
        </BannerHeadingContainer>
      </BannerContent>
    )
  
  // show loader until contest data is fetch
  if (
    (contestType === 'checking' || contestType === 'dynamic') &&
    (isLoading || !contestData)
  ) {
    return <Loader />
  }

  if (contestType === 'static') {
    const { template } = chooseContestObject[titleId]
    return (
      <>
        {template === 1 && <Template1 title={titleId} />}
        {template === 2 && <Template2 title={titleId} />}
      </>
    )
  }
  // if contest not found from API
  if (!isLoading && contestData && contestData.length === 0) {
    props.history.push('/404')
    return <div />
  }

  if (contestData) {
    return (
      <PublicPageBackButtonNavbar>
        <Container>
          <TopBannerSectionMobile />
          {(activeTab === 'detail' || !isWinnersPageLive) && (
            <SectionsContainer>
              <ExtraPadding>
                <section>
                  <SectionsCommonHeading>
                    {contestData.extra_info.contest_intro.intro}
                  </SectionsCommonHeading>
                  <StageContainer
                    heading={contestData.extra_info.heading}
                    sub_heading={contestData.extra_info.sub_heading}
                    end_date={contestData.extra_info.end_date}
                    result_date={contestData.extra_info.result_date}
                    min_words={contestData.extra_info.min_words}
                    notes={contestData.extra_info.notes}
                    important_points={contestData.extra_info.important_points}
                    toggleExtraInfoHandler={toggleExtraInfoHandler}
                    reward_notes={contestData.extra_info.reward_notes}
                    checkContestStatus={checkContestStatus}
                    handleJoinContestBtn={handleJoinContestBtn}
                    winner1_amount={contestData.extra_info.winner1_amount}
                    winner2_amount={contestData.extra_info.winner2_amount}
                    winner3_amount={contestData.extra_info.winner3_amount}
                    winner1_reward_note={
                      contestData.extra_info.winner1_reward_note
                    }
                    winner2_reward_note={
                      contestData.extra_info.winner2_reward_note
                    }
                    winner3_reward_note={
                      contestData.extra_info.winner3_reward_note
                    }
                    winner1_no={
                      contestData.extra_info.winner1_no
                    }
                    winner2_no={
                      contestData.extra_info.winner2_no
                    }
                    winner3_no={
                      contestData.extra_info.winner3_no
                    }
                    sub_heading_hyperlink={contestData?.extra_info?.sub_heading_hyperlink}
                    extraWinners={contestData?.extra_info?.extra_winners}
                    moneySymbol={isUSContest ? '$' : '₹'}
                    imp_reward_notes={contestData?.extra_info?.imp_reward_notes}
                  />
                  {contestData.extra_info.stage2 && (
                    <StageContainer
                      heading={contestData.extra_info.stage2.heading}
                      sub_heading={contestData.extra_info.stage2.sub_heading}
                      end_date={contestData.extra_info.stage2.end_date}
                      result_date={contestData.extra_info.stage2.result_date}
                      min_words={contestData.extra_info.stage2.min_words}
                      notes={contestData.extra_info.stage2.notes}
                      important_points={
                        contestData.extra_info.stage2.important_points
                      }
                      toggleExtraInfoHandler={toggleExtraInfoHandler}
                      reward_notes={contestData.extra_info.stage2.reward_notes}
                      checkContestStatus={checkContestStatus}
                      handleJoinContestBtn={handleJoinContestBtn}
                      imp_reward_notes={contestData?.extra_info?.stage2.imp_reward_notes}
                      winner1_amount={
                        contestData.extra_info.stage2.winner1_amount
                      }
                      winner2_amount={
                        contestData.extra_info.stage2.winner2_amount
                      }
                      winner3_amount={
                        contestData.extra_info.stage2.winner3_amount
                      }
                      winner1_no={
                        contestData.extra_info.stage2.winner1_no
                      }
                      winner2_no={
                        contestData.extra_info.stage2.winner2_no
                      }
                      winner3_no={
                        contestData.extra_info.stage2.winner3_no
                      }
                      winner1_reward_note={
                        contestData.extra_info.stage2.winner1_reward_note
                      }
                      winner2_reward_note={
                        contestData.extra_info.stage2.winner2_reward_note
                      }
                      winner3_reward_note={
                        contestData.extra_info.stage2.winner3_reward_note
                      }
                      sub_heading_hyperlink={contestData?.extra_info?.stage2?.sub_heading_hyperlink}
                      extraWinners={contestData?.extra_info?.stage2?.extra_winners}
                      moneySymbol={isUSContest ? '$' : '₹'}
                    />
                  )}
                </section>
                {/*  TODO Do we need to show certificate etc */}
                {/* <DummyCertificateSection> */}
                {/*   <SectionsCommonHeading> */}
                {/*     Receive Certificate for your Literary Excellence */}
                {/*   </SectionsCommonHeading> */}
                {/*   <img src={Certificate} width={'100%'} /> */}
                {/* </DummyCertificateSection> */}
                {/* { */}
                {/*   constants.showCertifiicateImg && <DummyCertificateSection> */}
                {/*     <SectionsCommonHeading> */}
                {/*       {constants.section_2_Heading} */}
                {/*     </SectionsCommonHeading> */}
                {/*     <img src={Certificate} width={'100%'} /> */}
                {/*   </DummyCertificateSection> */}
                {/* } */}
                {leaderboardData.popular && contestData?.locale !== 'US' && (
                  <LeaderBoard
                    contestId={contestData.contest_id}
                    setLeaderboardOpen={setLeaderboardOpen}
                    leaderboardData={leaderboardData}
                    defaultLeaderboardTab={defaultLeaderboardTab}
                    sectionMode
                  />
                )}

                {leaderboardData.popular && contestData?.locale !== 'US' &&(
                  <Popup
                    show={leaderboardOpen}
                    close={() => setThemeDetailsOpen({})}
                    className='WBPCardDetails'
                    closeMarksStyles={{ top: '20%' }}
                  >
                    <LeaderBoard
                      contestId={contestData.contest_id}
                      setLeaderboardOpen={setLeaderboardOpen}
                      leaderboardData={leaderboardData}
                      defaultLeaderboardTab={defaultLeaderboardTab}
                      seeAllRankings
                      contestData={contestData}
                    />
                  </Popup>
                )}

                {contestData?.extra_info?.themes_data &&
                  contestData?.extra_info?.themes_data.length > 0 && (
                    <ThemesIdeasSection
                      contestData={contestData}
                      setThemeDetailsOpen={setThemeDetailsOpen}
                      handleJoinContestBtn={handleJoinContestBtn}
                    />
                  )}
                {themeDetailsOpen.theme_name && (
                  <Popup
                    show
                    close={handleClosePopup}
                    className='WBPCardDetails'
                    closeMarksStyles={{ top: '20%' }}
                  >
                    <ThemesIdeasPage
                      themeData={themeDetailsOpen}
                      setThemeDetailsOpen={setThemeDetailsOpen}
                      handleJoinContestBtn={handleJoinContestBtn}
                      showNovelHandler={showNovelHandler}
                      contestData={contestData}
                    />
                  </Popup>
                )}
                <section>
                  <SectionsCommonHeading>
                    {/* {contestData.extra_info.tips_note} */}
                  </SectionsCommonHeading>
                  <SuspenseNovelsContainer>
                    {contestData.extra_info.reference_books.map((tipData) => (
                      <NovelContent key={tipData?.id}>
                        <ExampleNovelImg
                          src={tipData?.image_url}
                          alt={tipData?.id}
                          loading="lazy" 
                        />
                        <Button onClick={() => showNovelHandler(tipData.id, isUSContest)}>
                          {isUSContest ? 'Listen now' : 'Read now'}
                        </Button>
                      </NovelContent>
                    ))}
                  </SuspenseNovelsContainer>
                </section>
                <section>
                  <SectionsCommonHeading>
                    {contestData.extra_info.tips_note}
                  </SectionsCommonHeading>
                  <FlexContianerForStoryPoints>
                    {contestData.extra_info.tips_options.map(
                      (tipsData, index) => {
                        const display =
                          index + 1 === currentNotePoint ? 'block' : 'none'
                        return (
                          <NotesFlexItem key={index + 1} display={display}>
                            <BulbLogoContainer>
                              <ImportantNoteIcon />
                            </BulbLogoContainer>
                            <TipsHeading>TIP {index + 1}</TipsHeading>
                            <StoryWritingPoints> {tipsData}</StoryWritingPoints>
                          </NotesFlexItem>
                        )
                      }
                    )}
                  </FlexContianerForStoryPoints>
                  <NotesButtonForMobile>
                    {contestData.extra_info.tips_options.map(
                      (tipsData, index) => (
                          <NoteChangeButton
                            key={index}
                            onClick={() => updateNotePoint(index + 1)}
                            isActive={index + 1 === currentNotePoint}
                            data={index}
                          >
                            {index + 1}
                          </NoteChangeButton>
                        )
                    )}
                  </NotesButtonForMobile>
                </section>
              </ExtraPadding>
              <EarnBannerSection>
                <EarnWriterMessage>
                {isUSContest ? <> All writers are eligible for Writer’s Benefit Program after completion of 15K words audio series.</> : <>After completion of 30K words you can enter into <br />
                      Writer’s Benefit Program</>}
                </EarnWriterMessage>
                <VerticalLeftItems>
                  <EarnHeading color="#FFFFFF">
                    {isUSContest ? <>Earn min. 20% Revenue Share & other Bonuses !</> : <>Earn Upto 10 Lakh <br /> Per Year</>}
                  </EarnHeading>
                  <EarnSubHeading>
                    {isUSContest ? <> All writers are eligible for Writer’s Benefit Program after completion of 15K words audio series.</> : <>After completion of 30K words you can enter into <br />
                      Writer’s Benefit Program</>}
                  </EarnSubHeading>
                </VerticalLeftItems>
                {contestData.contest_id && (
                  <EarnBtnContainer>
                    <EarnSectionButton onClick={() => handleEarnButtonClick(isUSContest)}>
                      Learn more about the program{' '}
                      <ChevronRight fillOpacity="1" />
                    </EarnSectionButton>
                  </EarnBtnContainer>
                )}
              </EarnBannerSection>
              <ExtraPadding>
                <FaqSection>
                  <SectionsCommonHeading>
                    Frequently Asked Questions !
                  </SectionsCommonHeading>
                  {contestData.extra_info.faq.map((faq, index) => (
                    <Accordion key={index}>
                      <AccordionBtn onClick={toggleAccordionTextHandler}>
                        <div> {faq.ques} </div>
                      </AccordionBtn>
                      <AccordionText>{faq.ans}</AccordionText>
                    </Accordion>
                  ))}
                </FaqSection>
              </ExtraPadding>
            </SectionsContainer>
          )}
          {activeTab === 'winner' && isWinnersPageLive && (
            <SectionsContainer>
              <WinnerTopImg src={(isUSContest || contestData?.language !== 'hindi') ? HeadingImgUS : HeadingImg} alt="Congratulations" />
              {contestData?.extra_info?.stage2 ? (
                <WinnerH2>STAGE 1</WinnerH2>
              ) : null}
              <WinnerStage1>
                {contestData?.extra_info?.winners?.map((winner) => (
                  <WinnerDiv
                    key={winner?.book_id}
                    winner={winner}
                    handleBookClick={() => showNovelHandler(isUSContest ? winner?.show_id : winner?.book_id, isUSContest)}
                  />
                ))}
              </WinnerStage1>
              {contestData?.extra_info?.stage2?.winners ? (
                <WinnerH2>STAGE 2</WinnerH2>
              ) : null}
              <WinnerStage1>
                {contestData?.extra_info?.stage2?.winners?.map((winner) => (
                  <WinnerDiv
                    key={winner?.book_id}
                    winner={winner}
                    handleBookClick={() => showNovelHandler(isUSContest ? winner?.show_id : winner?.book_id, isUSContest)}
                  />
                ))}
              </WinnerStage1>
            </SectionsContainer>
          )}
        </Container>
      </PublicPageBackButtonNavbar>
    )
  }
}
